import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import AdminPage from '@/pages/aml/AdminPage';
import AlertDetailPage from '@/pages/aml/AlertDetailPage';
import AlertListingPage from '@/pages/aml/AlertListingPage';
import AmlDashboardPage from '@/pages/aml/AmlDashboardPage';
import BatchScreeningPage from '@/pages/aml/BatchScreeningPage';
import CaseDetailPage from '@/pages/aml/CaseDetailPage';
import CaseManagerPage from '@/pages/aml/CaseManagerPage';
import ManualScreeningPage from '@/pages/aml/ManualScreeningPage';
import RationaleConfigPage from '@/pages/aml/RationaleConfigPage';
import ScreeningConfigPage from '@/pages/aml/ScreeningConfigPage';
import ScreeningSchedulePage from '@/pages/aml/ScreeningSchedulePage';
import StrPage from '@/pages/aml/StrPage';
import ThresholdConfigPage from '@/pages/aml/ThresholdConfigPage';
import WatchlistIngestionPage from '@/pages/aml/WatchlistIngestionPage';
import WatchlistSearchPage from '@/pages/aml/WatchlistSearchPage';
import WhitelistPage from '@/pages/aml/WhitelistPage';
import { Routes } from '@/routes/routes';

export const amlRoutes: RouteObject[] = [
	{
		path: Routes.AML_ROOT,
		element: <Navigate to={Routes.AML_DASHBOARD} replace />,
	},
	{ path: Routes.AML_DASHBOARD, element: <AmlDashboardPage /> },
	{
		path: Routes.AML_SCREENING,
		element: <Navigate to={Routes.AML_ALERTS} replace />,
	},
	{
		path: Routes.AML_SCREENING_RESULTS,
		element: <Navigate to={Routes.AML_ALERTS} replace />,
	},
	{ path: Routes.AML_ALERTS, element: <AlertListingPage /> },
	{ path: Routes.AML_ALERT_DETAIL, element: <AlertDetailPage /> },
	{ path: Routes.AML_WHITELIST, element: <WhitelistPage /> },
	{ path: Routes.AML_CASE_MANAGER, element: <CaseManagerPage /> },
	{ path: Routes.AML_CASE_DETAIL, element: <CaseDetailPage /> },
	{ path: Routes.AML_CONFIG, element: <ScreeningConfigPage /> },
	{ path: Routes.AML_ADMIN, element: <AdminPage /> },
	{ path: Routes.AML_THRESHOLDS, element: <ThresholdConfigPage /> },
	{ path: Routes.AML_RATIONALE, element: <RationaleConfigPage /> },
	{ path: Routes.AML_MANUAL_SCREENING, element: <ManualScreeningPage /> },
	{ path: Routes.AML_WATCHLIST_SEARCH, element: <WatchlistSearchPage /> },
	{ path: Routes.AML_WATCHLIST_INGESTION, element: <WatchlistIngestionPage /> },
	{ path: Routes.AML_SCREENING_SCHEDULE, element: <ScreeningSchedulePage /> },
	{ path: Routes.AML_STR, element: <StrPage /> },
	// Backoffice-aligned URLs
	{ path: Routes.RR_CASE_MANAGER, element: <CaseManagerPage /> },
	{ path: Routes.RR_CASE_DETAIL, element: <CaseDetailPage /> },
	{ path: Routes.NS_MANUAL_SCREENING, element: <ManualScreeningPage /> },
	{ path: Routes.NS_WATCHLIST_SEARCH, element: <WatchlistSearchPage /> },
	{ path: Routes.NS_WATCHLIST_INGESTION, element: <WatchlistIngestionPage /> },
	{ path: Routes.NS_SCREENING_SCHEDULE, element: <ScreeningSchedulePage /> },
	{ path: Routes.NS_BATCH_SCREENING, element: <BatchScreeningPage /> },
	{ path: Routes.NS_THRESHOLD, element: <ThresholdConfigPage /> },
	{ path: Routes.NS_CONFIG, element: <ScreeningConfigPage /> },
];
